import { render } from "./CustomSlider.vue?vue&type=template&id=70bf02ef&scoped=true&ts=true"
import script from "./CustomSlider.vue?vue&type=script&lang=ts"
export * from "./CustomSlider.vue?vue&type=script&lang=ts"

import "./CustomSlider.vue?vue&type=style&index=0&id=70bf02ef&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bf02ef"]])

export default __exports__